import { requestConfig } from "../config.js";

/**
 * Сформировать ссылку на документ для ФЛ
 *
 * @param {Number} contractId
 * @param {String} billingId
 * @param {Number} documentId
 */
export async function apiDownloadDocumentHome(contractId, billingId, documentId) {
  return await requestConfig.get("/api/v0/agreement_conclusion/download_contract/", {
    params: {
      contract_id: contractId,
      billing_id: billingId,
      document_id: documentId,
    },
  });
}

/**
 * Подписать документ
 *
 * @param {Number} contractId
 * @param {String} billingId
 * @param {Number} documentId
 */
export async function apiSubscribeDocument(contractId, billingId, documentId) {
  await requestConfig.get("/api/v0/agreement_conclusion/signing_specific_document/", {
    params: {
      contract_id: contractId,
      billing_id: billingId,
      document_id: documentId,
    },
  });
}
